@for (
  notification of _.filter(notificationsService.items, 'route');
  track notification
) {
  <div>
    @if (types.includes(notification.value.type)) {
      <div
        class="ea-notifications-header mbl"
        [ngClass]="notification.style.backgroundColor"
        (click)="notificationsService.goToNotification(notification)"
      >
        <div>
          <svg-icon-sprite
            class="notification-icon rounded"
            [ngStyle]="{ color: notification.style.color }"
            src="assets/svg/sprite.svg#{{ notification.style.icon }}"
            [viewBox]="'0 0 24 24'"
            [width]="'24px'"
          >
          </svg-icon-sprite>
          <span>{{ notification.value.label }} </span>
          <span class="text-underline text-bold">
            Découvrir les recommandations</span
          >
          <span class="pull-right">
            <i class="fa fa-long-arrow-right text-bold"></i>
          </span>
        </div>
      </div>
    }
  </div>
}
